import walkVid1 from "../../../../src/images/random-walk-landscapes/01.mp4";
import walkVid2 from "../../../../src/images/random-walk-landscapes/02.mp4";
import * as React from 'react';
export default {
  walkVid1,
  walkVid2,
  React
};